module.exports = __webpack_public_path__ + "img/04.0ce73859.png";